<template>
    <div class="delete-account-container">
      <div class="delete-account-card">
        <!-- Icona azienda -->
        <img src="@/assets/icon.png" alt="Azienda Icon" class="azienda-icon" />
        
        <h2>Elimina il tuo account</h2>
        
        <!-- Form per username e password -->
        <form @submit.prevent="deleteAccount">
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" v-model="username" id="username" required />
          </div>
  
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" v-model="password" id="password" required />
          </div>
  
          <button type="submit" class="delete-button">Cancella Account</button>
        </form>
  
        <!-- Messaggio di feedback -->
        <div v-if="message" :class="messageClass" class="message">
          {{ message }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { CONFIG } from '@/config';
  export default {
    data() {
      return {
        username: '',
        password: '',
        message: '',
        messageClass: ''
      };
    },
    methods: {
        async deleteAccount() {
            try {
                // Effettua la chiamata API per eliminare l'account
                const response = await fetch(CONFIG.PROTOCOL + "://" + CONFIG.API_URL + ":" + CONFIG.PORT + '/api/auth/delete', {
                    method: 'DELETE',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                    mail: this.username,
                    password: this.password
                    })
                });

                // Legge il corpo della risposta come testo
                const responseBody = await response.text(); 
                console.log("Risposta dal server:", responseBody);
                
                if (response.status === 200) {
                    this.message = 'Utente eliminato correttamente!';
                    this.messageClass = 'success';
                } else if (response.status === 404) {
                    this.message = 'Utente non trovato';
                    this.messageClass = 'error';
                } else if (response.status === 401) {
                    this.message = 'Credenziali errate';
                    this.messageClass = 'error';
                } else if (response.status === 500) {
                    this.message = 'Errore generico, riprova più tardi';
                    this.messageClass = 'error';
                } else {
                    this.message = responseBody || 'Errore durante la cancellazione dell\'account!';
                    this.messageClass = 'error';
                }
                

            } catch (error) {
                this.message = 'Si è verificato un errore nella comunicazione con il server.';
                this.messageClass = 'error';
            }
        }
    }
}

  </script>
  
  <style scoped>
  .delete-account-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f4f4f4;
  }
  
  .delete-account-card {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    text-align: center;
  }
  
  .azienda-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  
  button {
    width: 100%;
    padding: 10px;
    background-color: #e74c3c;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #c0392b;
  }
  
  .message {
    margin-top: 20px;
    padding: 10px;
    border-radius: 5px;
  }
  
  .success {
    background-color: #27ae60;
    color: white;
  }
  
  .error {
    background-color: #e74c3c;
    color: white;
  }
  </style>
  